// src/features/editor/lib/imageFormats.ts
import type { CompressionType } from '@/api/uploadFile'

/** Растровые форматы баннеров и картинок уроков. GIF сюда НЕ входит: он только у маскотов. */
export const IMAGE_EXTS = ['.png', '.jpg', '.jpeg', '.webp']

/** Маскот дополнительно принимает GIF (анимация), бэк кладёт его в CDN без конвертации. */
export const MASCOT_ACCEPT_ATTR = 'image/png,image/jpeg,image/webp,image/gif'

/** GIF уходит с `gif` (бэк не конвертирует и проверяет сигнатуру), остальное — как баннер. */
export const uploadCompressionFor = (
  file: File,
): Extract<CompressionType, 'gif' | 'banner_compression'> =>
  file.type === 'image/gif' || file.name.toLowerCase().endsWith('.gif')
    ? 'gif'
    : 'banner_compression'
